"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var SiteCopy = /*#__PURE__*/function () {
  function SiteCopy(client) {
    (0, _classCallCheck2["default"])(this, SiteCopy);
    this.client = client;
    this.resourceUrl = '/admin';
  }

  (0, _createClass2["default"])(SiteCopy, [{
    key: "getSiteCopyParentCategoryData",
    value: function getSiteCopyParentCategoryData(ParentcategoryName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/site-copy/categories/").concat(ParentcategoryName), args);
    }
  }, {
    key: "updateSiteCopyParentCategoryData",
    value: function updateSiteCopyParentCategoryData(data, categoryId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.put("".concat(this.resourceUrl, "/site-copy/categories/").concat(categoryId), data, args);
    }
  }, {
    key: "getSiteCopySubCategoryData",
    value: function getSiteCopySubCategoryData(subCategoryId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/site-copy/sub-categories/").concat(subCategoryId), args);
    }
  }, {
    key: "updateSiteCopySubCategoryData",
    value: function updateSiteCopySubCategoryData(subCategoryId, data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.put("".concat(this.resourceUrl, "/site-copy/sub-categories/").concat(subCategoryId), data, args);
    }
  }]);
  return SiteCopy;
}();

exports["default"] = SiteCopy;